import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300/80 bg-background-100/60 px-6 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-200/70 text-foreground-500">
        <i className="ri-file-search-line text-2xl" aria-hidden="true"></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            {actionLabel}
          </button>
        ) : null}
        {secondaryLabel && secondaryTo ? (
          <Link
            to={secondaryTo}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/80 px-5 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
          >
            {secondaryLabel}
          </Link>
        ) : null}
      </div>
    </div>
  );
}